import { routes } from '../config/api_routes'

export const alertService = {

    storeAlert: (formData) => {    
        return window.axios.post(routes.storeAlertApi,formData)
    },

    getProducts: () => {
        return window.axios.post(routes.getProductListApi);
    },

    getSubProducts: (formData) => {
        return window.axios.post(routes.getSubProductListApi,formData);
    },

    getAlerts (formData) {
        return window.axios.post(routes.getAlertsListapi,formData);
    },

    getAlertById (formData) {
        return window.axios.post(routes.getAlertById,formData);
    },

    updateAlert(formData) {
        return window.axios.post(routes.updateAlert,formData);
    },

    deleteAlert(formData) {
        return window.axios.post(routes.deleteAlertApi,formData);
    }
}